import { createSlice } from "@reduxjs/toolkit";
import {
  fetchCategories,
  fetchSubcategories,
  fetchSubcategoriesProducts,
} from "../actions/CategoriesAction";

//categories Slice
const categoriesSlice = createSlice({
  name: "categories",
  initialState: {
    categories: [],
    subcategories: {},
    pagination: {},

    subcategoryProducts: {
      byCategory: {},
      pagination: {},
    },
    isLoadingProducts: false,
    error: null,
    isLoading: false,
  },
  reducers: {
    clearCategoriesState: (state) => {
      state.categories = [];
      state.error = null;
      state.pagination = {};
      state.subcategories = {};
      state.subcategoryProducts = {};
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCategories.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchCategories.fulfilled, (state, action) => {
        state.isLoading = false;
        state.categories = action.payload.data;
      })
      .addCase(fetchCategories.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload.message;
      })

      .addCase(fetchSubcategories.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchSubcategories.fulfilled, (state, action) => {
        state.isLoading = false;
        const { categoryId, data } = action.payload;
        // //console.log('=== SLICE: FETCH SUBCATEGORIES FULFILLED ===');
        // //console.log('Category ID:', categoryId, 'Type:', typeof categoryId);
        // //console.log('Data:', data);
        // //console.log('Data type:', typeof data, 'Is Array:', Array.isArray(data));
        // //console.log('Data length:', data?.length);
        // //console.log('Pagination:', action.payload.pagination);
        
        // //console.log('Before update - subcategories state:', state.subcategories);
        
        state.subcategories[categoryId] = data;
        state.pagination[categoryId] = action.payload.pagination;
        
        // //console.log('After update - subcategories state:', state.subcategories);
        // //console.log('Specific category data after update:', state.subcategories[categoryId]);
        // //console.log('=== END SLICE UPDATE ===');
      })
      .addCase(fetchSubcategories.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload.message;
      })
      .addCase(fetchSubcategoriesProducts.pending, (state) => {
        state.isLoadingProducts = true;
        state.error = null;
      })
      .addCase(fetchSubcategoriesProducts.fulfilled, (state, action) => {
        state.isLoadingProducts = false;
        const { data, pagination } = action.payload;
        state.subcategoryProducts.byCategory = { data };
        state.subcategoryProducts.pagination = pagination;
      })
      .addCase(fetchSubcategoriesProducts.rejected, (state, action) => {
        state.isLoadingProducts = false;
        state.error = action.payload.message;
      });
  },
});

export const { clearCategoriesState } = categoriesSlice.actions;
export default categoriesSlice.reducer;
